import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';

const RoleBasedRedirect = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated && user) {
      // Only redirect if user is on the home page
      if (location.pathname === '/') {
        switch (user.role) {
          case 'super_user':
            navigate('/super-admin');
            break;
          case 'garage_admin':
            navigate('/garage-admin');
            break;
          case 'customer':
            // Regular users stay on home page or go to bookings
            // navigate('/bookings');
            break;
          default:
            // Unknown role, stay on home page
            break;
        }
      }
    }
  }, [isAuthenticated, user, location.pathname, navigate]);

  return children;
};

export default RoleBasedRedirect;